import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Globe, CheckCircle } from "@phosphor-icons/react";
import { api } from "../context/AuthContext";
import { VikiAvatar } from "../components/VikiAvatar";

const GIORNI = ["dom", "lun", "mar", "mer", "gio", "ven", "sab"];
const fmtDay = (iso) => {
  try {
    const d = new Date(iso + "T00:00:00");
    return `${GIORNI[d.getDay()]} ${iso.slice(8, 10)}/${iso.slice(5, 7)}`;
  } catch {
    return iso;
  }
};

export default function MarketingIniziativaSitoPage() {
  const { site } = useParams();
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get(`/viki/marketing-initiatives/${site}`).then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, [site]);

  const toggleDone = async (i) => {
    const it = items[i];
    const next = !it.done;
    setItems(items.map((x, j) => (j === i ? { ...x, done: next } : x)));
    try {
      await api.post("/viki/marketing-tips/done", { day: it.day, index: it.index, done: next });
    } catch {
      setItems(items.map((x, j) => (j === i ? { ...x, done: !next } : x)));
    }
  };

  const fatte = (items || []).filter((x) => x.done).length;

  return (
    <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-testid="iniziativa-sito-page">
      <Link to="/marketing/iniziative" className="inline-flex items-center gap-1.5 text-xs text-white/40 hover:text-white mb-6" data-testid="sito-back-link">
        <ArrowLeft size={13} /> Iniziative
      </Link>
      <div className="flex items-end justify-between gap-4 mb-8 animate-fade-up">
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-white/40 mb-2 inline-flex items-center gap-1.5"><Globe size={13} /> Sito</p>
          <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tighter leading-none">{site}</h1>
          {items && (
            <p className="text-sm text-slate-400 mt-3">
              {items.length} iniziative negli ultimi 30 giorni · <span className="text-emerald-300">{fatte} completate</span>
            </p>
          )}
        </div>
        <VikiAvatar size={44} />
      </div>

      {!items ? (
        <p className="text-sm text-white/40">Caricamento…</p>
      ) : items.length === 0 ? (
        <p className="text-sm text-white/40">Nessuna iniziativa ancora per questo sito: la prima arriva domattina.</p>
      ) : (
        <div className="flex flex-col gap-3">
          {items.map((t, i) => (
            <div key={`${t.day}-${t.index}`}
              className={`rounded-xl border p-4 transition-colors ${t.done ? "border-emerald-400/30 bg-emerald-400/[0.05]" : "border-white/10 bg-white/[0.03]"}`}
              data-testid={`sito-tip-${i}`}>
              <div className="flex items-center justify-between gap-2 mb-1.5">
                <span className="text-[11px] font-bold tracking-wide text-cyan-300">{fmtDay(t.day)}</span>
                <span className={`text-[10px] px-2 py-0.5 rounded-full border shrink-0 ${(t.costo || "zero") === "zero" ? "text-emerald-300 border-emerald-400/40" : "text-amber-300 border-amber-400/40"}`}>
                  costo {t.costo || "zero"}
                </span>
              </div>
              <p className={`text-sm font-semibold mb-1 ${t.done ? "line-through text-white/45" : ""}`}>{t.titolo}</p>
              <p className="text-xs text-white/60 leading-relaxed">{t.azione}</p>
              {t.perche && <p className="text-[11px] text-white/35 mt-1.5 italic">{t.perche}</p>}
              {t.misura && <p className="text-[11px] text-cyan-200/50 mt-1">Da misurare: {t.misura}</p>}
              <button data-testid={`sito-tip-done-${i}`} onClick={() => toggleDone(i)}
                className={`mt-2.5 inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-full border transition-colors ${t.done
                  ? "text-emerald-300 border-emerald-400/50 bg-emerald-400/10"
                  : "text-white/50 border-white/15 hover:text-emerald-300 hover:border-emerald-400/40"}`}>
                <CheckCircle size={13} weight={t.done ? "fill" : "regular"} /> {t.done ? "Fatta" : "Segna come fatta"}
              </button>
            </div>
          ))}
        </div>
      )}
    </main>
  );
}
